import BaseService from './_base.service';

export const categoryblogService = {
    page,
    edit,
    create,
    one,
    remove,
    search,
    removeLogic,
    combo
};

function page(page,size, callback) {
    return BaseService.get("/categoryblog/page/"+page+"/"+size, callback, true)
}

function combo(callback) {
    return BaseService.get("/categoryblog/combo/", callback, true)
}
function search(page,size,filter, callback) {
    return BaseService.post("/categoryblog/page/"+page+"/"+size,filter, callback, true)
}
function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/categoryblog/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/categoryblog/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/categoryblog/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/categoryblog/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/categoryblog/"+id+"/logic", callback);
}
